import React, { useState } from 'react';
import styled from 'styled-components';
import YouTubeEmbed from 'components/YouTubeEmbed'
import { Card, CardBody, Heading, Text, TextArea, Flex, Input, Button } from '@thenexlabs/uikit';
import { useTranslation } from 'contexts/Localization';

const PageInfo = styled.div`
  text-align: left;
  margin: auto 50px;
  min-height: 70vh;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: auto;
`;

const MissionDiv = styled(Text)`
  margin-top: 100px;
  margin-bottom: 200px;
`;

const mission = "At NEX Level Gaming, our mission is to redefine the gaming landscape through The NEX, our innovative cross-platform metaverse experience. We are dedicated to creating immersive, social, and competitive virtual worlds that empower players to explore, connect, and thrive. By leveraging cutting-edge WebGL and WebXR technologies, we aim to shape the future of gaming and the metaverse. With features like NFT-driven rewards, competitive duels, and collaborative dungeons, The NEX offers a dynamic ecosystem designed for both casual gamers and dedicated competitors. As we push the boundaries of what's possible in gaming, we remain committed to providing unparalleled experiences for players worldwide. Stay tuned as we transform the way you play and interact in virtual worlds.";

const team = [
  {
    name: 'Jonathan Catalano',
    title: 'Founder/Lead Nerd',
    profilePic: '/images/nex-team/jon-dp.png',
    linkedIn: 'https://www.linkedin.com/in/jon-catalano/',
    about: '',
  },
  {
    name: 'Michael Morra',
    title: 'Senior Unity Developer',
    profilePic: '/images/nex-team/mike-dp.png',
    linkedIn: 'https://www.linkedin.com/in/michael-morra-a370a4238/',
    about: '',
  }
];

const AboutNex = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageInfo>
        <Heading scale="xxl" mt="50px" mb="20px">
          {t('Our Team')}
        </Heading>
        <TeamGrid>
          {team.map((member) => (
            <div key={member.name}>
              <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', flexDirection: 'column', textAlign: 'center' }}>
                <a href={member.linkedIn} target="_blank" rel="noopener noreferrer">
                  <img
                    width={'200'}
                    height={'200'}
                    src={member.profilePic}
                    style={{ borderRadius: '50%', boxShadow: '0px 0px 15px rgba(0, 255, 0, 0.5)' }}
                    layout="fixed"
                    objectFit="cover"
                    unoptimized={true}
                    priority
                    alt={member.name}
                  />
                </a>
                <Heading scale="xl" mt="10px" mb="5px">
                  {member.name}
                </Heading>
                <Heading scale="lg" color="secondary" mb="10px">
                  {member.title}
                </Heading>
              </div>
            </div>
          ))}
        </TeamGrid>
        <MissionDiv color="secondary">
          <Heading scale="xxl" mt="50px" mb="20px">
            {t('Our Mission')}
          </Heading>
          {mission}
        </MissionDiv>
        <Flex
          flex="1"
          flexDirection="column"
          style={{
            maxWidth: '800px', margin: 'auto', marginTop: '-150px', marginBottom: '100px',
            boxShadow: '0px 0px 20px #17FF12', borderRadius: '5px', overflow: 'hidden'
          }}
        > 
          <YouTubeEmbed height='400px' url="https://www.youtube.com/watch?v=sxIy6p36Ejo"/>
        </Flex>
      </PageInfo>
    </>
  );
};

export default AboutNex;
